import { ItemType } from "antd/lib/breadcrumb/Breadcrumb";
import snakeCase from "lodash-es/snakeCase";
import path from "path";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

type Breadcrumb = keyof typeof breadcrumbToPath;

const breadcrumbToPath = {
  infrastructure: {
    path: "/infrastructure",
  },
  infrastructureLicenses: {
    path: "/infrastructure/licenses",
  },
  administration: {
    path: "/administration",
  },
  administrationUsers: {
    path: "/administration/users",
  },
  billing: {
    path: "/billing",
  },
  billingPurchases: {
    path: "/billing/purchases",
  },
  settings: {
    path: "/settings",
  },
  settingsBasic: {
    path: "/settings/basic",
  },
  reporting: {
    path: "/reporting",
  },
  reportingMachineGroups: {
    path: "/reporting/machine/groups",
  },
  reportingMachineStatus: {
    path: "/reporting/machine/status",
  },
};

export const useBreadcrumb = (...breadcrumbs: Breadcrumb[]) => {
  const { t } = useTranslation();

  const items = breadcrumbs.map((b) => {
    return {
      ...breadcrumbToPath[b],
      breadcrumbName: t(`main_menu.${snakeCase(b)}` as any),
    };
  });

  const itemRender: (item: ItemType) => React.ReactNode = (item: ItemType) => {
    if (!item.path) {
      return item.breadcrumbName;
    }

    return <Link to={item.path}>{item.breadcrumbName}</Link>;
  };

  return { items, itemRender };
};
